import { render, staticRenderFns } from "./impress.vue?vue&type=template&id=2cb6e9de&scoped=true&"
import script from "./impress.vue?vue&type=script&lang=js&"
export * from "./impress.vue?vue&type=script&lang=js&"
import style0 from "./impress.vue?vue&type=style&index=0&id=2cb6e9de&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6e9de",
  null
  
)

export default component.exports